import { render } from "./SectionIndexProfile.vue?vue&type=template&id=6507ffbe&scoped=true"
import script from "./SectionIndexProfile.vue?vue&type=script&lang=js"
export * from "./SectionIndexProfile.vue?vue&type=script&lang=js"

import "./SectionIndexProfile.vue?vue&type=style&index=0&id=6507ffbe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6507ffbe"]])

export default __exports__